// removed by extract-text-webpack-plugin
module.exports = {"field_unit_number":"_17akK","field_unit_type":"UgXPB","field_street_number":"_2xuz6","field_street_name":"_2adoM","field_street_type":"_1idU5","field_suburb":"knR38","field_state":"_2H6nb","field_postcode":"_2oNfO","field":"_66Dgm","form_error":"_2JwGd","field_break":"_2IU9f","field_select":"_2rxV0"};


//////////////////
// WEBPACK FOOTER
// ./components/Address/styles.scss
// module id = 590
// module chunks = 0